window.dtAbsenceLeave = function () {
  const dt_absence_leave = new DataTable('#absence-request-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#absence-request-datatable').data('source'),
      data: function (d) {
        d.kind = $("#absence-request-datatable").attr('kind')
      },
      beforeSend: function () { showLoadingRow('#absence-request-datatable', 9); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'desc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "begin_date" },
      { "data": "end_date" },
      { "data": "code" },
      { "data": "employee_fn" },
      { "data": "employee_ln" },
      { "data": "leafe" },
      { "data": "total_day" },

    ],
    columnDefs: [],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
      $('td:eq(5)', row).html(`${data.employee_fn} ${data.employee_ln}`);
      $('td:eq(5)', row).attr('colspan', 2);
      $('td:eq(6)', row).remove()
    },
  });

  dtFinalTouch()
}
